module.exports = __webpack_public_path__ + "static/key-visual-77416e30470e5fdffd761900d327be45.jpg";